import React, { Component } from 'react';
import { connect } from 'react-redux'

import Header from '../../components/Header'

class Cheader extends Component{
    langChange(lang){
               
    }
    
    render(){
        return (
            <div>
                <Header appState={this.props.appState} 
                        back={this.props.back}
                        backPage = {this.props.backPage}
                        branch={this.props.branch}
                        language={this.props.branch}
                        langChange={this.langChange}
                        plate={this.props.plate}
                        user={this.props.user}
                        version={this.props.version}/>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
      appState: state.app.appState,
      back: state.app.back,
      backPage: state.app.backPage,
      branch: state.profile.branch,
      language: state.app.language,
      plate: state.app.plate,
      user: state.profile.user,
      version: state.app.version
    }
}

export default connect(mapStateToProps)(Cheader);



// WEBPACK FOOTER //
// ./src/containers/Cheader/index.js